<template>
  <div class="nav-bar">
    <div class="left"><slot name="left"></slot> </div>
    <div class="center"><slot name="center"></slot> </div>
    <div class="right"><slot name="right"></slot> </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NavBar"
}
</script>

<style scoped>
.nav-bar{
  display: flex;
  padding-top: 150px;
  height: 54px;
  line-height: 54px;
  text-align: center;
  color: #30353d;
  /*box-shadow: 0 1px 1px rgba(100,100,100,.1);*/
}
.left, .right{
  width: 140px;
  height: 54px;
  /*background-color: red;*/
}
.center{
  flex: 1;
  width: 800px;
  height: 54px;
  /*background-color: blue;*/
}
</style>
